export const theme = {
  colors: {
    blue: "#002f6c",
    lightBlue: "#63c6dc",
    darkBlue: "#001838",
    red: "#ff8275",
    darkRed: "#842c41",
    brown: "#af8373",
    green: "#3bbba3",
    darkGreen: "#005c5d",
    gold: "#cfa867",
    white: "#ffffff",
    blueop: "#002d6c40",
    buttons: ["#4267B2", "#006AFF", "#1DA1F2", "#0E76A8"],
    overflow: "hidden",
  },
}
